exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#card-item-accordion input, \n#card-item-accordion input::placeholder, \n#card-item-accordion label,\n.MuiMenu-list {\n  font-size: 0.75rem !important;\n}", ""]);

